var swiper = new Swiper(".horizontale-kacheln", {
    slidesPerView: '2',
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    breakpoints: {
        640: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 16,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
        },
    },
});

var swiper = new Swiper(".textimgtext", {
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlides: true,
    loop: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
            centeredSlides: false,
            loop: false,
        },
    },
});

var swiper = new Swiper(".horizontale-kacheln.leistungen", {
    slidesPerView: '2',
    spaceBetween: 16,
    centeredSlides: true,
    loop: true,
    breakpoints: {
        640: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 44,
            centeredSlides: false,
            loop: false,
        },
    },
});

var swiperOptions = {
    spaceBetween: 10,
    loop: true,
    autoplay: {
        delay: 1,
    },
    slidesPerView: '1',
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 50,
        },
        1300: {
            slidesPerView: 3,
            spaceBetween: 50,
        },

    },
    speed: 6500,
};

var swiper = new Swiper(".logos", swiperOptions);


var swiper = new Swiper(".team", {
    spaceBetween: 40,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next-team",
        prevEl: ".swiper-button-prev-team",
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            centeredSlides: false,
        },
        1300: {
            slidesPerView: 4,
            centeredSlides: false,
        },

    },
});

var swiper = new Swiper(".stimmen.grid", {
    slidesPerView: 1,
    spaceBetween: 24,
    grid: {
        rows: 2,
        fill: "row",
    },
    breakpoints: {
        768: {
            spaceBetween: 60,
            slidesPerView: 2,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next-stimmengrid",
        prevEl: ".swiper-button-prev-stimmengrid",
    },
    pagination: {
        el: ".swiper-pagination-stimmengrid",
        type: "fraction",
    },
});

var swiper = new Swiper(".stimmen.slider", {
    slidesPerView: 1,
    spaceBetween: 58,
    navigation: {
        nextEl: ".swiper-button-next-stimmenslider",
        prevEl: ".swiper-button-prev-stimmenslider",
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
    },
});

var swiper = new Swiper(".babygalerie", {
    slidesPerView: 1,
    spaceBetween: 24,
    grid: {
        rows: 2,
        fill: "row",
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next-babygalerie",
        prevEl: ".swiper-button-prev-babygalerie",
    },
    pagination: {
        el: ".swiper-pagination-babygalerie",
        type: "fraction",
    },
});
